// Convert product to SEO-friendly URL slug
export function createProductSlug(product) {
  const manufacturer = product.manufacturer || "";
  const name = product.name || "";

  // Combine manufacturer + product name
  const fullName = `${manufacturer} ${name}`.toLowerCase();

  // Remove special characters, replace spaces with hyphens
  const slug = fullName
    .replace(/[^a-z0-9\s-]/g, "") // Remove special chars
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single
    .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens

  // Use MPN or SKU - add with DOUBLE UNDERSCORE separator to avoid conflicts
  const identifier = product.mpn || product.sku;
  return `${slug}__${identifier}`;
}

// Extract MPN from slug
export function extractMpnFromSlug(slug) {
  // MPN is after the double underscore
  const parts = slug.split("__");
  return parts[parts.length - 1];
}
